'use strict';

export function findHostInstance(_ref) {
  return null;
}
//# sourceMappingURL=findHostInstance.js.map